import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/img/zeronine.png';
import { Image } from '@chakra-ui/react';

const Footer = () => {
   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
   const [currentPage, setCurrentPage] = useState('home');
   const [activeSection, setActiveSection] = useState('home');

   const navigateToPage = (page) => {
      setCurrentPage(page);
      setActiveSection(page);
      setMobileMenuOpen(false);

      // Navigate to the route
      if (page === 'home') {
         window.location.href = '/';
      } else if (page === 'about') {
         window.location.href = '/about';
      }
   };
   const scrollToSection = (section) => {
      setMobileMenuOpen(false);
      if (currentPage !== 'home') {
         setCurrentPage('home');
         setTimeout(() => {
            document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
         }, 100);
      } else {
         document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
      }
   };

   return (
      <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white pt-20 px-4">
         <style>{`
            .footer-link {
               position: relative;
               display: inline-block;
            }
            
            .footer-link::after {
               content: '';
               position: absolute;
               width: 0;
               height: 2px;
               bottom: -2px;
               left: 0;
               background: linear-gradient(90deg, #3b82f6, #8b5cf6);
               transition: width 0.3s ease;
            }
            
            .footer-link:hover::after {
               width: 100%;
            }
            
            .footer-link:hover {
               color: white;
               transform: translateX(4px);
            }

            .app-store-btn {
               transition: all 0.3s ease;
            }
            
            .app-store-btn:hover {
               transform: translateY(-3px);
               box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);
            }
         `}</style>

         <div className="max-w-7xl mx-auto">
            <div className="grid md:grid-cols-4 gap-12 mb-16">
               <div>
                  <div className="flex items-center gap-3 mb-6">
                     <Image src={Logo} alt="ZeroNine Logo" width={'200px'} />
                  </div>
                  <p className="text-gray-400 mb-6 leading-relaxed">
                     India's most intelligent accounting software powered by AI
                  </p>
                  <div className="space-y-2 mb-6">
                     <p className="text-gray-400 text-sm">
                        <span className="font-semibold">Email :</span> help@zeronine.ai
                     </p>
                     <p className="text-gray-400 text-sm">
                        <span className="font-semibold">Phone :</span> +91 72839-90909
                     </p>
                  </div>
               </div>

               <div>
                  <h5 className="font-black mb-6 text-lg">Quick links</h5>
                  <ul className="space-y-3 text-gray-400">
                     <li>
                        <button
                           onClick={() => navigateToPage('home')}
                           className="footer-link transition-all duration-300">
                           Home
                        </button>
                     </li>
                     <li>
                        <Link to={'/about'} className="footer-link transition-all duration-300">
                           About Us
                        </Link>
                     </li>
                     <li>
                        <button
                           onClick={() => scrollToSection('pricing')}
                           className="footer-link transition-all duration-300">
                           Pricing
                        </button>
                     </li>
                     <li>
                        <button
                           onClick={() => scrollToSection('features')}
                           className="footer-link transition-all duration-300">
                           Features
                        </button>
                     </li>
                     <li>
                        <button
                           onClick={() => scrollToSection('testimonials')}
                           className="footer-link transition-all duration-300">
                           Reviews
                        </button>
                     </li>
                  </ul>
               </div>

               <div>
                  <h5 className="font-black mb-6 text-lg">Legal</h5>
                  <ul className="space-y-3 text-gray-400">
                     <li>
                        <Link to={'/termsofservice'} className="footer-link transition-all duration-300">
                           Terms of Service
                        </Link>
                     </li>
                     <li>
                        <Link to={'/privacypolicy'} className="footer-link transition-all duration-300">
                           Privacy Policy
                        </Link>
                     </li>
                     <li>
                        <Link to={'/refundpolicy'} className="footer-link transition-all duration-300">
                           Refund & Cancellation Policy
                        </Link>
                     </li>
                     <li>
                        <Link to={'/helpsupport'} className="footer-link transition-all duration-300">
                           Help & Support
                        </Link>
                     </li>
                  </ul>
               </div>

               {/* App Store Buttons */}
               <div>
                  <h6 className="font-semibold mb-3 text-sm">Download Our App</h6>
                  <div className="flex flex-row gap-2 flex-wrap">
                     <a
                        href="https://play.google.com/store/apps/details?id=com.ss.zeronine.app"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="app-store-btn inline-flex items-center gap-2 bg-black rounded-lg px-3 py-2 border border-gray-700 hover:border-blue-500">
                        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none">
                           <path
                              d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92z"
                              fill="#32BBFF"
                           />
                           <path d="M14.5 12.707l3.842 3.842-10.25 5.902 6.408-9.744z" fill="#F4B400" />
                           <path
                              d="M18.342 16.549l3.654-2.103c.394-.227.658-.594.658-1.063 0-.469-.264-.836-.658-1.063l-3.654-2.103-3.842 3.841 3.842 3.491z"
                              fill="#FF5B57"
                           />
                           <path d="M8.092 1.348L18.342 7.25l-3.842 3.842L8.092 1.348z" fill="#60D669" />
                        </svg>
                        <div className="text-left">
                           <p className="text-xs text-gray-400">GET IT ON</p>
                           <p className="text-xs font-semibold">Google Play</p>
                        </div>
                     </a>

                     <a
                        href="https://apps.apple.com/in/app/09-ai/id6747242947"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="app-store-btn inline-flex items-center gap-2 bg-black rounded-lg px-3 py-2 border border-gray-700 hover:border-blue-500">
                        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                           <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
                        </svg>
                        <div className="text-left">
                           <p className="text-xs text-gray-400">Download on the</p>
                           <p className="text-xs font-semibold">App Store</p>
                        </div>
                     </a>
                  </div>
               </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-800 text-center pb-5">
               <p className="text-gray-500 text-lg">Copyright © {new Date().getFullYear()} Zeronine Pvt. Ltd.</p>
            </div>
         </div>
      </footer>
   );
};

export default Footer;
